import React from "react";
import { Box, CircularProgress } from "@mui/material";
import SummaryFilterCard from "./SummaryFilterCard";
import SummaryTable from "./SummaryTable";
import { useSalesContext } from "../../SalesContext";
import useFilterOptions from "./useFilterOptions";

interface MainSummaryComponentProps {
  user_id: string;
}

const MainSummaryComponent: React.FC<MainSummaryComponentProps> = ({
  user_id,
}) => {
  const { kpiData } = useSalesContext();
  const { filterOptions, isLoading, error } = useFilterOptions(user_id || "");

  const summaryCoverageData = kpiData?.summaryCoverage || [
    {
      name: "Grand Total",
      id: null,
      uniqueDoctor: 0,
      visitFrequencyPer: 0,
      missedCall: 0,
      doctorCallAverage: 0,
      noOfDoctorCall: 0,
    },
  ];
  const summaryFieldWork = kpiData?.summaryFieldWork || [
    {
      name: "Grand Total",
      id: null,
      mr_Working_Days: 0,
      flm_Mr_Working_Days: 0,
    },
  ];

  if (isLoading || !kpiData) {
    return (
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        Error: {error}
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 3, p: 2, borderRadius: "8px" }}>
      <SummaryFilterCard filterOptions={filterOptions} />
      <SummaryTable title="Coverage" data={summaryCoverageData} />
      <SummaryTable title="Field Work" data={summaryFieldWork} />
    </Box>
  );
};

export default MainSummaryComponent;
